import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import getCropFormat from 'commons/getCropFormat';
import getProductImageBaseImgixParams from 'commons/getProductImageBaseImgixParams';
import useScreen from 'hooks/useScreen';
import isT1Image from 'commons/isT1Image';
import JBImage from '.';
const JBProductImage = props => {
  const $ = _c(26);
  const {
    isMobileOrTablet
  } = useScreen();
  let isConfiguration;
  let isStudio;
  let otherProps;
  let t0;
  if ($[0] !== isMobileOrTablet || $[1] !== props) {
    t0 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        enableCropIfCropFactorAvailable,
        isFullScreenGallery: t1,
        onError,
        type,
        ...jbImageProps
      } = props;
      const isFullScreenGallery = t1 === undefined ? false : t1;
      isConfiguration = type === "configuration" || type === "cylindo";
      isStudio = type === "studio";
      const isT1 = isT1Image(props.src);
      const {
        enableCrops: t2,
        crops,
        cropFormat: initialCropFormat,
        ...t3
      } = jbImageProps;
      otherProps = t3;
      const enableCrops = t2 === undefined ? false : t2;
      const cropFormat = enableCropIfCropFactorAvailable || initialCropFormat || getCropFormat({
        enableCrops,
        isMobileOrTablet
      });
      if (cropFormat && crops?.[cropFormat]) {
        t0 = <JBImage {...jbImageProps} enableCrops={!!enableCropIfCropFactorAvailable || enableCrops} cropFormat={cropFormat} onError={onError} />;
        break bb0;
      }
      if (enableCrops && (isConfiguration || isStudio)) {
        let finalProps = {
          ...getProductImageBaseImgixParams({
            type,
            src: props.src,
            crops,
            enableCrops,
            isMobileOrTablet
          }),
          ...jbImageProps
        };
        if (isFullScreenGallery && isStudio && isT1) {
          let t4;
          if ($[6] !== finalProps) {
            t4 = {
              ...finalProps,
              fit: "max",
              fillColor: "fff",
              pad: 240,
              trimTol: 2,
              bg: "F5F6F8"
            };
            $[6] = finalProps;
            $[7] = t4;
          } else {
            t4 = $[7];
          }
          finalProps = t4;
          if (isMobileOrTablet) {
            let t5;
            if ($[8] !== finalProps) {
              t5 = {
                ...finalProps,
                pad: 80
              };
              $[8] = finalProps;
              $[9] = t5;
            } else {
              t5 = $[9];
            }
            finalProps = t5;
          }
        }
        if (isFullScreenGallery && isConfiguration) {
          let t4;
          if ($[10] !== finalProps) {
            t4 = {
              ...finalProps
            };
            $[10] = finalProps;
            $[11] = t4;
          } else {
            t4 = $[11];
          }
          finalProps = t4;
          if (isMobileOrTablet) {
            let t5;
            if ($[12] !== finalProps) {
              t5 = {
                ...finalProps
              };
              $[12] = finalProps;
              $[13] = t5;
            } else {
              t5 = $[13];
            }
            finalProps = t5;
          }
        }
        let t4;
        if ($[14] !== finalProps || $[15] !== onError) {
          t4 = <JBImage {...finalProps} onError={onError} />;
          $[14] = finalProps;
          $[15] = onError;
          $[16] = t4;
        } else {
          t4 = $[16];
        }
        t0 = t4;
        break bb0;
      }
    }
    $[0] = isMobileOrTablet;
    $[1] = props;
    $[2] = isConfiguration;
    $[3] = isStudio;
    $[4] = otherProps;
    $[5] = t0;
  } else {
    isConfiguration = $[2];
    isStudio = $[3];
    otherProps = $[4];
    t0 = $[5];
  }
  if (t0 !== Symbol.for("react.early_return_sentinel")) {
    return t0;
  }
  const t1 = isConfiguration ? "color" : undefined;
  const t2 = isConfiguration ? 50 : undefined;
  const t3 = isStudio ? "2:1" : undefined;
  const t4 = isStudio ? "center" : undefined;
  let t5;
  if ($[17] !== otherProps || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t4) {
    t5 = {
      trim: t1,
      trimPad: t2,
      ar: t3,
      crop: t4,
      ...otherProps
    };
    $[17] = otherProps;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  const imageProps = t5;
  let t6;
  if ($[23] !== imageProps || $[24] !== props) {
    t6 = <JBImage {...imageProps} {...props} />;
    $[23] = imageProps;
    $[24] = props;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
};
JBProductImage.propTypes = {
  crops: PropTypes.shape({
    '1x1': PropTypes.object,
    '3x2': PropTypes.object
  }),
  enableCropIfCropFactorAvailable: PropTypes.bool,
  enableCrops: PropTypes.bool,
  isFullScreenGallery: PropTypes.bool,
  onError: PropTypes.func,
  src: PropTypes.string,
  type: PropTypes.oneOf(['studio', 'configuration'])
};
export default JBProductImage;